import { contentTypes } from '~/models'
import {
  AccordionList,
  ActionItem,
  ActionSection,
  ActionTable,
  ContentBlock,
  ClaimStatus,
  ContactBlock,
  ContactForm,
  ContactItemAddress,
  ContactItemEmailAddress,
  ContactItemLink,
  ContactItemOpenText,
  ContactItemPhone,
  ContentAlignedText,
  ContentHR,
  ContentImageWrap,
  Document,
  DocumentList,
  FullWidthCard,
  FullWidthImage,
  DownloadBlock,
  ImageBlock,
  ContentAlertBlock,
  ReferenceList,
  Reference,
  CallToAction,
  AnchorTag,
  SplitContentContactBlock,
  ContentFormattedText,
  InternalLink
} from '#components'

// Define the mapping of content types to their respective components
const components: { [key: string]: any } = {
  //puzzle-components
  [contentTypes.action_item.codename]: ActionItem,
  [contentTypes.action_section.codename]: ActionSection,
  [contentTypes.claim_status.codename]: ClaimStatus,
  [contentTypes._contact_item___address.codename]: ContactItemAddress,
  [contentTypes._contact_item___email___.codename]: ContactItemEmailAddress,
  [contentTypes._contact_item___link.codename]: ContactItemLink,
  [contentTypes._contact_item___open_text.codename]: ContactItemOpenText,
  [contentTypes._contact_item__phone__.codename]: ContactItemPhone,
  [contentTypes._content___aligned_text.codename]: ContentAlignedText,
  [contentTypes._content___hr.codename]: ContentHR,
  [contentTypes.content_image_wrap.codename]: ContentImageWrap,
  [contentTypes.content_alert_block.codename]: ContentAlertBlock,
  [contentTypes.document.codename]: Document,
  [contentTypes.split_content_downloads.codename]: DownloadBlock,
  [contentTypes.full_width_image.codename]: ImageBlock,
  [contentTypes.split_content_contact_block.codename]: SplitContentContactBlock,
  [contentTypes.formatted_text.codename]: ContentFormattedText,
  [contentTypes.internal_link.codename]: InternalLink,

  //puzzles
  [contentTypes.action_table.codename]: ActionTable,
  [contentTypes.basic_content_block.codename]: ContentBlock,
  [contentTypes.contact_block.codename]: ContactBlock,
  [contentTypes.contact_form.codename]: ContactForm,
  [contentTypes.document_list.codename]: DocumentList,
  [contentTypes.full_width_card.codename]: FullWidthCard,
  [contentTypes._reference_list.codename]: ReferenceList,
  [contentTypes._reference.codename]: Reference,
  [contentTypes.accordion_list.codename]: AccordionList,
  [contentTypes.call_to_action.codename]: CallToAction,
  [contentTypes.anchor_tag.codename]: AnchorTag
}

export default function (type: string) {
  return components[type]
}
